import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileIcon } from '@tanium/react-graphics';
import { Label } from '@tanium/react-label';
import { PageSection } from '@tanium/react-page-section';
import { Notification } from '@tanium/react-persistent-notifications';
import { Stack } from '@tanium/react-stack';
import { TextWithIcon } from '@tanium/react-text-with-icon';
import { AddPaymentMethodMenu } from './AddPaymentMethodMenu';

// The section reads no billing data, so it shows a free trial with no payment method.
export const BillingSection: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <PageSection
      title={<TextWithIcon leadingIcon={FileIcon}>{t('Billing')}</TextWithIcon>}
      additionalTitleContent={
        <Stack width="100%" justifyContent="space-between" alignItems="center" itemSpacing={2}>
          <Label>{t('No payment method')}</Label>
          <AddPaymentMethodMenu />
        </Stack>
      }
    >
      <Notification role="note" type="info">
        {t('No payment method on file. Add one before trial end to maintain access.')}
      </Notification>
    </PageSection>
  );
};
